import styled from 'styled-components';
import { colors } from '@alixpartners/ui-components';

export const BreadcrumbsList = styled.ul`
	margin-right: auto;
	display: inline-block;
	list-style: none;
	color: ${colors.grey8};
	z-index: 1;
	line-height: 24px;
	margin: 0;
`;

export const BreadcrumbsListItem = styled.li`
	margin: 16px 0;
	display: inline-block;
	font-size: 16px;
	font-weight: 500;
	letter-spacing: 0.3px;
	text-transform: none;
	cursor: pointer;
	color: ${colors.grey6};

	&:hover {
		color: ${colors.green2};
	}

	& + &:before {
		padding: 8px 3px 8px 5px;
		content: '/';
	}

	&:last-child {
		cursor: default;
		color: ${colors.grey8};
		&:hover {
			color: ${colors.grey8};
		}
	}
`;

export const LargeBreadcrumbListItem = styled(BreadcrumbsListItem)`
	font-size: 23px;
	margin: 14px 0;
	line-height: 31px;
	cursor: default;
`;
